














import { Component, Vue ,Watch} from "vue-property-decorator";
import { getUrlParam } from '@/utils/common';

// @ts-ignore
import One from "@/components/magic/one.vue";
import Two from "@/components/magic/two.vue";
import Three from "@/components/magic/three.vue";
interface Imagic {
  title: string;
  magicArr: {
    name: string;
    content: {
      picName: string;
      route: {
        type: string;
        id: string;
      };
    }[];
  }[];
}

@Component({
  name: "TiktokIndex",
  components: {
    One,
    Two,
    Three,
  },
})
export default class TiktokIndex extends Vue {
  id = '';
  scene = '';
  appid='';
  magicData={
    title:'',
    id:'',
    packetId:'',
    magicArr:{}
  };
  clickid = ''; // 抖音数据回传的clickid

  @Watch('$route')
  public onRouteChanged() {
    this.initParams()
  }

  created() {
    this.initParams()

    // @ts-ignore
    // eslint-disable-next-line no-undef,@typescript-eslint/camelcase
    _baq.track('page_view', {assets_id: '1733051113843725'});
    this.clickid = getUrlParam('clickid');

    // @ts-ignore
    window.aplus_queue.push({
      action: "aplus.sendPV",
      arguments: [{ is_auto: false }],
    });
  }
  initParams(){
    this.id = getUrlParam('id') || '1518858590070444032';
    if(!this.id){
      return this.$toast.fail('参数错误')
    }
    this.scene = getUrlParam('scene') || '3209'; //默认抖音
    this.appid = getUrlParam('appid') || '2021002145618078'; //默认俏机
    import(`./${this.id}.js`).then(module => {
      console.log('module--->',module.default);
      this.magicData=module.default
      document.title = this.magicData.title;
    })
  }
  goPage(item: any) {
    // @ts-ignore
    // eslint-disable-next-line no-undef,@typescript-eslint/camelcase
    _baq.track('shopping', {assets_id: '1733051113843725'});

      this.trackEvent(item)
      this.path(item.route)
  }

  path(item: any) {
    const pathPrefix = 'https://ds.alipay.com/';
    const schemePrefix = `alipays://platformapi/startapp?appId=${this.appid}`;
    const queryStr = `${encodeURIComponent(`scene=${this.scene}&clickid=${this.clickid}`)}`;

    switch (item.type) {
      case 'DISABLE':
        return;
      case 'DETAIL':
        window.location.href = `${pathPrefix}?scheme=${encodeURIComponent(`${schemePrefix}&page=pagesA/product/productdetail${encodeURIComponent(`?id=${item.id}`)}&query=${queryStr}`)}`;
        break;
      case 'ACTIVITY':
        window.location.href = `${pathPrefix}?scheme=${encodeURIComponent(`${schemePrefix}&page=pagesB/live/dyActivity${encodeURIComponent(`?id=${this.magicData.id}&packetId=${this.magicData.packetId}`)}&query=${queryStr}`)}`;
        break;
      case 'MAGIC':
        window.location.href = `${pathPrefix}?scheme=${encodeURIComponent(`${schemePrefix}&page=pagesA/activity/magic${encodeURIComponent(`?id=${this.magicData.id}&packetId=${this.magicData.packetId}`)}&query=${queryStr}`)}`;
        break;
      case 'INDEX':
        window.location.href = `${pathPrefix}?scheme=${encodeURIComponent(`${schemePrefix}&page=pages/index/index&query=${queryStr}`)}`;
        break;
      default:
        window.location.href = `${pathPrefix}?scheme=${encodeURIComponent(`${schemePrefix}&page=pages/index/index&query=${queryStr}`)}`;
        break;
    }
  }
  trackEvent(item: any) {
    // @ts-ignore
    const {aplus_queue} = window;
    aplus_queue.push({
      action: "aplus.record",
      arguments: [
        'qiaoji-tiktok',
        "CLK",
        {
          picName: item.picName,
          id: item.route.id,
        },
      ],
    });
  }
}
